// ============================================================
// 函館"整う海"セット 単品注文制限スクリプト
// 対象 variant ID を他の商品と同時にカートに入れられないようにする
// ============================================================

const TOTONOU_VARIANT_ID = 53714561040597;

const TOTONOU_ERROR_MESSAGE =
  '海鮮セットは北海道発送のため、単品でのご注文をお願いしております。恐れ入りますが、カートを空にして再度お試しください。';

/**
 * カートの現在の中身を取得する
 */
async function fetchCart() {
  const res = await fetch('/cart.js');
  return res.json();
}

/**
 * 追加しようとしている variant ID に対してバリデーションを行う
 * @param {number|string} variantId
 * @returns {{ ok: boolean, message?: string }}
 */
async function validateCartAddition(variantId) {
  const cart = await fetchCart();
  const cartItems = cart.items;

  const isTotonou = Number(variantId) === TOTONOU_VARIANT_ID;
  const cartHasTotonou = cartItems.some(
    (item) => item.variant_id === TOTONOU_VARIANT_ID
  );
  const cartHasOtherItems = cartItems.some(
    (item) => item.variant_id !== TOTONOU_VARIANT_ID
  );

  // 函館セットを追加しようとしているが、カートに他の商品が既にある
  if (isTotonou && cartHasOtherItems) {
    return { ok: false, message: TOTONOU_ERROR_MESSAGE };
  }

  // 他の商品を追加しようとしているが、カートに函館セットが既にある
  if (!isTotonou && cartHasTotonou) {
    return { ok: false, message: TOTONOU_ERROR_MESSAGE };
  }

  return { ok: true };
}

/**
 * エラーメッセージを画面に表示する
 * Dawn テーマのエラー表示領域を探して挿入し、見つからなければ alert にフォールバック
 */
function showCartError(message) {
  // 既存のエラー表示要素を探す（Dawn テーマの各パターンに対応）
  const selectors = [
    '.product-form__error-message',
    '.product-form__error-message-wrapper',
    '.cart-notification__info',
    '.cart__warnings',
  ];

  let shown = false;

  for (const selector of selectors) {
    const els = document.querySelectorAll(selector);
    els.forEach((el) => {
      el.textContent = message;
      el.removeAttribute('hidden');
      el.style.display = 'block';
      el.style.color = 'red';
      shown = true;
    });
  }

  // どこにも表示できなければ alert にフォールバック
  if (!shown) {
    alert(message);
  }
}

// ============================================================
// 1) フォーム送信のインターセプト（通常の Add to Cart フォーム）
// ============================================================
document.addEventListener(
  'submit',
  async (e) => {
    const form = e.target;
    if (!form.matches('[action*="/cart/add"]')) return;

    const variantInput = form.querySelector('[name="id"]');
    if (!variantInput) return;

    const variantId = variantInput.value;
    const result = await validateCartAddition(variantId);

    if (!result.ok) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showCartError(result.message);
    }
  },
  true // capture phase でインターセプトし、Dawn の JS より先に動かす
);

// ============================================================
// 2) fetch のインターセプト（Dawn テーマの JS カートに対応）
// ============================================================
const _originalFetch = window.fetch;

window.fetch = async function (input, init) {
  const url = typeof input === 'string' ? input : (input?.url ?? '');

  if (url.includes('/cart/add')) {
    let variantId = null;

    // POST body を解析して variant ID を取り出す
    if (init?.body) {
      const body = init.body;

      if (typeof body === 'string') {
        // JSON 形式
        try {
          const parsed = JSON.parse(body);
          variantId = parsed.id ?? parsed.items?.[0]?.id ?? null;
        } catch {
          // URLSearchParams 形式
          const params = new URLSearchParams(body);
          variantId = params.get('id');
        }
      } else if (body instanceof FormData) {
        variantId = body.get('id');
      } else if (body instanceof URLSearchParams) {
        variantId = body.get('id');
      }
    }

    if (variantId) {
      const result = await validateCartAddition(variantId);

      if (!result.ok) {
        showCartError(result.message);

        // 422 エラーレスポンスを返してカート追加をブロック
        return new Response(
          JSON.stringify({ status: 422, message: result.message }),
          {
            status: 422,
            headers: { 'Content-Type': 'application/json' },
          }
        );
      }
    }
  }

  return _originalFetch.apply(this, arguments);
};